import { render, staticRenderFns } from "./page.vue?vue&type=template&id=4e962a51&"
import script from "./page.vue?vue&type=script&lang=ts&"
export * from "./page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e962a51')) {
      api.createRecord('4e962a51', component.options)
    } else {
      api.reload('4e962a51', component.options)
    }
    module.hot.accept("./page.vue?vue&type=template&id=4e962a51&", function () {
      api.rerender('4e962a51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/page.vue"
export default component.exports